import Request from './request';
import consts from "@/consts.js";

async function fetch(data) {
    return Request('get', "api/waves/", data);
}

async function fetchOne(id, data) {
    return Request('get', "api/waves/"+ id, data);
}

async function distributionsPrint(id) {// 批量打印波次内配送单
    var data = {};
    data.limit = consts.limitAll; //获取全部
    data.itemsPerPage = consts.limitAll; //获取全部
    return Request('get', "api/waves/distributions-print/"+ id, data);
}

async function pickingPrint(id) {//拣货单打印
    var data = {};
    data.limit = consts.limitAll; //获取全部
    data.itemsPerPage = consts.limitAll; //获取全部
    return Request('get', "api/waves/pickingPrint/"+ id, data);
}

async function batchPickingPrint(data) {
    return Request('get', "api/waves/batch-picking-print/", data);
}

async function save(id, data) {
    if (id) {
        return Request('post', "api/waves/edit?id=" + id, data);
    } else {
        return Request('post', "api/waves/add" , data);
    }
}

async function stockOrderList(data) {
    return Request('get', "api/waves/stock-order-list", data)
}

async function add(data) {
    return Request('post', "api/waves/add", data)
}

async function getErrMaterialOutDetail(data) {
    return Request('patch', "api/waves/get-unable-add-wave-out-details", data);
}

async function saveErrMaterialOutDetail(data) {
    return Request('patch', "api/waves/edit-unable-add-wave-out-details", data);
}

async function receive(data) {
    return Request('post', "api/waves/receive-wave", data)
}

async function getPickingList(data){
    return Request('get', "api/waves/get-wave-picking-list", data)
}

async function getStockPosition(data) {
    return Request('get', "api/waves/get-stock-position", data)
}

async function saveStoragePick(data){
    return Request('patch', "api/waves/save-storage-pick", data)
}

async function submitWavePicking(data){
    return Request('post', "api/waves/submit-wave-picking", data)
}

async function release(data){
    return Request('patch', "api/waves/wave-release", data)
}

async function getSortingInfoList(wave_id,stock_id){
    return Request('get', "api/waves/get-wait-sorting-info-list?wave_id=" + wave_id + "&stock_id=" + stock_id)
}

async function stockOrderContainerBinding(data) {
    return Request('patch', "api/waves/stock-order-container-binding", data)
}

async function getWaitSortingDetail(data) {
    return Request('get', "api/waves/get-wait-sorting-detail", data)
}

async function lockMaterialSorting(data) {
    return Request('patch', "api/waves/lock-sorting", data)
}

async function submitWaveSorting(data) {
    return Request('post', "api/waves/submit-sorting", data)
}

async function forceCompleteSorting(data) {
    return Request('post', "api/waves/force-complete-sorting", data)
}

async function getPickAndSortingList(id) {
    return Request('get', "api/waves/get-pick-and-sorting-list/"+ id)
}

async function shopDistributionsPrint(id) {// 打印门店配送单
    var data = {};
    data.limit = consts.limitAll; //获取全部
    data.itemsPerPage = consts.limitAll; //获取全部
    return Request('get', "api/waves/shop-distributions-print/"+ id, data);
}

export default {
    fetch,
    fetchOne,
    distributionsPrint,
    save,
    stockOrderList,
    add,
    getErrMaterialOutDetail,
    saveErrMaterialOutDetail,
    receive,
    getPickingList,
    getStockPosition,
    saveStoragePick,
    submitWavePicking,
    release,
    getSortingInfoList,
    stockOrderContainerBinding,
    getWaitSortingDetail,
    lockMaterialSorting,
    submitWaveSorting,
    forceCompleteSorting,
    getPickAndSortingList,
    shopDistributionsPrint,
    pickingPrint,
    batchPickingPrint,
};